/** ⚡ badge surfaced when a ticker reports earnings within EARNINGS_WINDOW_DAYS.
 *
 * The lightning bolt is rendered as an emoji to match the same vocabulary
 * used elsewhere — the Discover "Earnings this week" filter chip and the
 * Telegram digest's "⚡ Earnings this week" line.
 */

const EARNINGS_WINDOW_DAYS = 7;

function daysUntil(iso: string): number {
  const target = new Date(iso + "T00:00:00Z").getTime();
  const now = new Date();
  const todayUtc = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Math.round((target - todayUtc) / (1000 * 60 * 60 * 24));
}

export function isEarningsWeek(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const d = daysUntil(iso);
  return d >= 0 && d <= EARNINGS_WINDOW_DAYS;
}

export default function EarningsBadge({ date }: { date: string | null | undefined }) {
  if (!isEarningsWeek(date)) return null;
  const d = daysUntil(date!);
  const label =
    d === 0 ? "today" : d === 1 ? "tomorrow" : `in ${d}d`;
  return (
    <span
      title={`Earnings ${label} (${date})`}
      className="inline-flex items-center gap-0.5 rounded-full bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-semibold text-amber-300 ring-1 ring-inset ring-amber-500/30"
    >
      <span aria-hidden="true" className="leading-none">⚡</span>
      {label}
    </span>
  );
}
